import type { IconData } from '@stacksjs/iconify-core'

export const smileyIndiferentFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24 1.5C11.574 1.5 1.5 11.574 1.5 24S11.574 46.5 24 46.5S46.5 36.426 46.5 24S36.426 1.5 24 1.5\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M16 30a2 2 0 1 0 0 4h16a2 2 0 1 0 0-4zm-5-12a2 2 0 0 1 2-2h6a2 2 0 1 1 0 4h-6a2 2 0 0 1-2-2m18-2a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4z\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default smileyIndiferentFlat
